
export default [
    {
        path: '/admin/tax-ranges',
        name: 'tax-ranges',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/tax-range/index.vue')
    }
]